import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WSProvider } from './contexts/WSContext';

import CustomerLogin from './pages/customer/CustomerLogin';
import CustomerRegister from './pages/customer/CustomerRegister';
import CustomerHome from './pages/customer/CustomerHome';
import CustomerPayment from './pages/customer/CustomerPayment';
import CustomerWaiting from './pages/customer/CustomerWaiting';
import CustomerTracking from './pages/customer/CustomerTracking';
import CustomerHistory from './pages/customer/CustomerHistory';
import CustomerWallet from './pages/customer/CustomerWallet';

function Guard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="mobile-shell flex items-center justify-center">
      <img src="/logo.png" alt="logo" className="w-24 h-24 object-contain animate-bounce" />
    </div>
  );
  if (!user) return <Navigate to="/cliente/login" replace />;
  if (user.role !== 'customer') {
    localStorage.removeItem('token');
    return <Navigate to="/cliente/login" replace />;
  }
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <div className="mobile-shell">
      <Toaster position="top-center" toastOptions={{ style: { fontSize: 14, borderRadius: 12 } }} />
      <Routes>
        <Route path="/" element={
          user && user.role === 'customer'
            ? <Navigate to="/cliente/home" replace />
            : <Navigate to="/cliente/login" replace />
        } />
        <Route path="/cliente/login" element={<CustomerLogin />} />
        <Route path="/cliente/cadastro" element={<CustomerRegister />} />
        <Route path="/cliente/home" element={<Guard><CustomerHome /></Guard>} />
        <Route path="/cliente/carteira" element={<Guard><CustomerWallet /></Guard>} />
        <Route path="/cliente/pagamento/:orderId" element={<Guard><CustomerPayment /></Guard>} />
        <Route path="/cliente/aguardando/:orderId" element={<Guard><CustomerWaiting /></Guard>} />
        <Route path="/cliente/rastreio/:orderId" element={<Guard><CustomerTracking /></Guard>} />
        <Route path="/cliente/historico" element={<Guard><CustomerHistory /></Guard>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WSProvider>
          <AppRoutes />
        </WSProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
